/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import Select from "react-select";
import { AgentService } from "../../../../utils/services/agent.service";
import { ManagerService } from "../../../../utils/services/manager.service";

function Body({ domainBrand, partnerAgent = [] }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");

  const [partner, setPartner] = useState("");
  const [pcn, setPcn] = useState("");
  const [loading, setLoading] = useState(false);

  const unlockTransaction = async (transactionId, imtoId) => {
    setLoading(true);
    try {
      const response = await ManagerService.unlockTransaction(
        transactionId,
        imtoId
      );
      if (response.data.status === "SUCCESS") {
        toast.success("Transaction unlocked successfully");
        setPcn("");
        setPartner("");
        setLoading(false);
      } else {
        toast.error(response?.data?.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const transactionId = partner?.value;
  const imtoArr = partnerAgent?.map((i) => {
    return { label: i?.name, value: i?.id };
  });

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["l_beneficiary_authorisation"]
                : "Beneficiary Authorization"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12">
            <div className="card overflow-hidden">
              <div className="card-body">
                <form
                  className="needs-validation"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="form-row">
                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_PLEASE_SELECT_PARTNE_-1226449852"]
                          : "Please select partner you wish to pay-out on behalf."}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <Select
                        options={imtoArr}
                        isClearable={false}
                        isSearchable={true}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        name="country"
                        value={partner}
                        onChange={(option) => setPartner(option)}
                      />
                    </div>
                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {/* {dictionary
                          ? dictionary["WO_PAYMENT_COLLECTION_N_475179274"]
                          : "Payment Collection Number (PCN) provided by beneficiary(NOTED: This activity has been recorded as part of fraud prevention audit)."} */}
                        Payment Collection Number (PCN) provided by beneficiary
                        <span style={{ color: "red" }}> *</span>
                      </label>

                      <input
                        className="form-control"
                        type="pcn"
                        name="pcn"
                        value={pcn}
                        id="password"
                        onChange={(event) => setPcn(event.target.value)}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-lg-6 col-md-6" />
                    <div className="col-lg-6 col-mg-6">
                      <button
                        disabled={pcn !== "" ? false : true}
                        className="login100-form-btn btn-primary fw-bold"
                        onClick={() => unlockTransaction(pcn, transactionId)}
                        type={"button"}
                      >
                        UNLOCK{" "}
                        {loading ? (
                          <>
                            &nbsp;
                            <i className="fa fa-spinner fa-spin" />
                          </>
                        ) : (
                          ""
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
